import { html, LitElement } from 'lit-element';

import { getPercentage, latexToHTML } from '../headerBlocks/utils.js';

/**
 * @element view-details-modal-math-inline
 * @prop {Object} response - Response
 * IMPORTANT: ONLY DISPLAYED FOR CORRECT RESPONSE
 */
export class ViewDetailsModalMathInline extends LitElement {
  static get properties() {
    return {
      response: {
        type: Object,
        attribute: false,
      },
      completeAnswer: { type: String, attribute: false },
    };
  }

  createRenderRoot() {
    return this;
  }

  render() {
    const { item } = this.response || {};
    const { expression, responses } = item || {};

    let occurrences = 0;
    let completeAnswer = '';

    if (expression) {
      completeAnswer = expression.replace(/\{\{[^}]*\}\}/g, () => {
        if (responses[occurrences]) {
          occurrences += 1;
          // eslint-disable-next-line no-plusplus
          return responses[occurrences - 1].answer;
        }

        return '';
      });
    }

    if (!expression || !responses) return '';

    const { studentsNr, studentsAnsweredNr = 1 } = this.response || {};
    const percentage = getPercentage(studentsNr, studentsAnsweredNr);

    return html`<div>
      <div class="modal-response-content">
        <div class="modal-response-content-row view-modal-mer">
          <math-rendering-element
            .label="${completeAnswer
              ? latexToHTML(completeAnswer)
              : 'Loading...'}"
          ></math-rendering-element>
        </div>
        <div>
          <br />
          <b>Note</b>: The answer shown above is the primary correct answer
          specified by the author for this item, but other answers may also be
          recognized as correct.
        </div>
        <br />
      </div>

      <div class="header-students-number">
        ${studentsNr} Student${studentsNr === 1 ? '' : 's'} (${percentage}%)
      </div>
    </div>`;
  }
}

export default ViewDetailsModalMathInline;
